<template>
  <div>
    <div class="order-info" v-if="orderInfo">
      <div class="order-status" v-if="orderInfo.tradeStatus == 'WAIT_BUYER_PAY'">
        <van-icon name="clock-o" size="48" color="#FAAB0C" />
        <h3>待付款</h3>
      </div>
      <div class="order-status" v-else-if="orderInfo.tradeStatus == 'TRADE_CLOSED'">
        <van-icon name="close" size="48" color="#EE0A24" />
        <h3>交易关闭</h3>
      </div>
      <div class="order-status" v-else-if="orderInfo.tradeStatus == 'TRADE_SUCCESS'">
        <van-icon name="passed" size="48" color="#07c160" />
        <h3>支付成功</h3>
      </div>
      <div class="order-status" v-else-if="orderInfo.tradeStatus == 'TRADE_FINISHED'">
        <van-icon name="close" size="48" color="#323233" />
        <h3>交易结束</h3>
      </div>

      <div class="order-detail" v-if="orderInfo">
        <ul>
          <li>
            <span class="item-text">交易单号</span>
            <span class="item-value">{{orderInfo.tradeNo}}</span>
          </li>
          <li>
            <span class="item-text">交易金额</span>
            <span class="item-value">{{orderInfo.totalPrice}}</span>
          </li>
          <li>
            <span class="item-text">下单时间</span>
            <span class="item-value">{{orderInfo.tradeRequestTime|dateFormat("YYYY-MM-DD HH:mm:ss")}}</span>
          </li>
        </ul>
      </div>

      <div class="order-detail" v-if="orderInfo">
        <ul>
          <li>
            <span class="item-text">当前状态</span>
            <span class="item-value">已预约</span>
          </li>
          <li>
            <span class="item-text">体检人员</span>
            <span class="item-value">{{orderInfo.name}}</span>
          </li>
          <li>
            <span class="item-text">联系手机</span>
            <span class="item-value">{{orderInfo.mobile | mask("phone")}}</span>
          </li>
          <li>
            <span class="item-text">体检机构</span>
            <span class="item-value">{{hospInfo.name}}</span>
          </li>
          <li>
            <span class="item-text">体检地点</span>
            <span class="item-value">{{hospInfo.address}}</span>
          </li>
          <li>
            <span class="item-text">体检时间</span>
            <span class="item-value">{{orderInfo.appointDate}} {{orderInfo.appointTimeRangeName}}</span>
          </li>
          <li>
            <span class="item-text">体检套餐</span>
            <span class="item-value">{{orderInfo.packageName}}</span>
          </li>
          <li>
            <span class="item-text">预约编号</span>
            <span class="item-value">{{orderInfo.orderNo}}</span>
          </li>
        </ul>
      </div>
    </div>
    <!-- <div class="order-action">
      <van-cell title="检前须知" is-link />
      <van-cell title="联系客服" is-link />
      <van-cell title="服务评价" is-link />
    </div> -->

    <div class="order-action">
      <van-button size="large" type="info" @click="$router.push('/')">返回</van-button>
    </div>
  </div>
</template>

<style lang="less" scoped>
  .order-info {
    background: #fff;
    padding: 32px 24px;
    margin-bottom: 12px;
    text-align: center;

    .order-status {
      padding-bottom: 24px;
      margin-bottom: 24px;
      border-bottom: 1px solid #ebedf0;

      h3 {
        font-size: 20px;
        margin-top: 8px;
      }
    }

    .order-detail {
      text-align: left;
      font-size: 14px;

      li {
        list-style: none;
        display: flex;
        line-height: 32px;

        .item-text {
          width: 80px;
          color: #888;
        }

        .item-value {
          flex: 1;
        }
      }
    }
  }

  .order-action {
    padding: 12px;
    background: #fff;
  }
</style>

<script>
  import {
    mapState,
    mapMutations,
    mapActions
  } from "vuex";
  import {
    getUserOrder
  } from "@/api/order";
  export default {
    name: "orderPayResult",
    data() {
      return {
        name: this.$route.params.name,
        orderInfo: null,
      }
    },
    mounted() {
      this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: '加载中',
      });
      let _this = this;
      _this.$router.onReady(() => {
        setTimeout(() => {
          if (_this.$route.matched.length === 0) {
            _this.$router.push("/");
          }
          // console.log(_this.payResponse);
          // if (_this.payResponse == null) {
          //   _this.$toast.fail("无效的参数");
          //   // setTimeout(() => {
          //   //   _this.$router.replace('/');
          //   // }, 2000);
          // }
          // let orderNo = _this.payResponse.out_trade_no;
          // let hospId = _this.hospInfo.code;
          let hospId = _this.$route.query.hospid;
          let orderNo = _this.$route.query.orderNo;
          this.getHospitalInfo(hospId);
          getUserOrder(hospId, orderNo)
            .then(res => {
              _this.orderInfo = res.data;
            })
            .catch(err => {
              console.log(err)
            })
            .finally(
              () => {
                _this.$Toast.clear();
              }
            );
        }, 1000);
      });
    },
    computed: {
      ...mapState({
        hospInfo: state => state.hospital.hospInfo
      }),
      payResponse() {
        let bizContent = this.$route.query.biz_content;
        if (bizContent) {
          return JSON.parse(bizContent);
        } else {
          return null;
        }
        //return_url?app_id=2014072300007148
        //& biz_content = {
        //    "sub_code": "5001",
        //    "sub_msg": "用户取消",
        //    "out_trade_no": "20150320010101001",
        //    "trade_no": "2016082221001004590259242589",
        //    "total_amount": 88.88,
        //    "trade_status": "TRADE_CLOSED"
        // }
        // &code=10000
        // &method=lc.trade.h5.pay.return
        // &msg=支付回调
        // &nonce_str=377ba369-292f-4058-a74b-e6fea606d01a
        // &sign=
        // &sign_type=rsa
        // &timestamp=2014-07-24 03:07:50 

        // 交易状态说明
        // WAIT_BUYER_PAY	交易创建，等待买家付款
        // TRADE_CLOSED	未付款交易超时关闭，或支付完成后全额退款
        // TRADE_SUCCESS	交易支付成功
        // TRADE_FINISHED	交易结束，不可退款
      }
    },
    methods: {
      ...mapActions(
        "hospital", {
          getHospitalInfo: "getHospitalInfo"
        }
      ),
    },
  }
</script>